import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a63aef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sbomPackageDetail-container" }
const _hoisted_2 = { class: "sbomPackageDetail-main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sbomPackageDetail-title" }, "软件包详情", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sbom_data = _resolveComponent("sbom-data")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_SbomVulnerabilityTable = _resolveComponent("SbomVulnerabilityTable")!
  const _component_package_dependency = _resolveComponent("package-dependency")!
  const _component_upstream_and_patchInfo = _resolveComponent("upstream-and-patchInfo")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
        type: "card",
        class: "sbomPackageDetailTabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "SBOM 元数据",
            name: "sbomData"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_sbom_data, {
                sbomData: _ctx.packageDetails,
                vulnerabilityData: _ctx.vulnerabilityData
              }, null, 8, ["sbomData", "vulnerabilityData"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "CVE",
            name: "bug"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SbomVulnerabilityTable, {
                packageId: _ctx.$route.params.id.toString(),
                productName: _ctx.productName
              }, null, 8, ["packageId", "productName"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "软件包依赖",
            name: "package"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_package_dependency)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "上游社区&Patch",
            name: "upstreamAndPatch"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_upstream_and_patchInfo)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}